import { Product, ProductCreate, ProductUpdate } from "../../api";
import { ProductEntry } from "../../types";

export const productsCreateToExternal = (
  entry: ProductEntry,
): ProductCreate => ({
  name: entry.name,
  sales_contract_template_id: entry.sales_contract_template_id ?? null,
  purchase_contract_template_id: entry.purchase_contract_template_id ?? null,
});

export const productsUpdateToExternal = (
  entry: Partial<ProductEntry>,
): ProductUpdate => {
  return {
    name: entry.name,
    sales_contract_template_id: entry.sales_contract_template_id ?? null,
    purchase_contract_template_id: entry.purchase_contract_template_id ?? null,
  };
};

export const productsFromExternalList = (entry: Product): ProductEntry => ({
  id: entry.id,
  name: entry.name,
  sales_contract_template_id: entry.sales_contract_template_id,
  purchase_contract_template_id: entry.purchase_contract_template_id,
  sales_contract_template: entry.sales_contract_template,
  purchase_contract_template: entry.purchase_contract_template,
  commentsCount: entry.comments_count,
});
